module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bttn",
    on: {
      "click": _vm.open
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.createuser_button.create_user')))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-de106c38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateCalendars/CreateUser/CreateUserButton.vue
// module id = 2142
// module chunks = 1